import React from 'react';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import DoneIcon from '@material-ui/icons/Done';

const styles = ({ spacing }: Theme) => createStyles({
    root: {
        margin: spacing(0.5)
    }
  });

export type OnToggleHandler = (state: boolean) => void;

class DepartmentChip extends React.Component<{ department: string, onToggle?: OnToggleHandler } & WithStyles<typeof styles>, { enabled: boolean }> {

    constructor(props: { department: string, onToggle?: OnToggleHandler } & WithStyles<typeof styles>) {
        super(props);
        this.state = { enabled: true };
    }

    private readonly handleClick = () => {
        this.setState(prev => {
            this.props.onToggle?.(!prev.enabled);
            return { ...prev, enabled: !prev.enabled };
        });
    }

    private readonly chipProps = (enabled: boolean) => {
        if (!enabled) {
            return {};
        }
    
        return {
            onDelete: this.handleClick,
            color: 'primary' as const,
            deleteIcon: <DoneIcon />
        };
    };

    render() {
        const { classes, department } = this.props;
        return <li>
                 <Chip
                   label={department}
                   clickable
                   onClick={this.handleClick}
                   className={classes.root}
                   { ...this.chipProps(this.state.enabled) }
                 />
               </li>
    }
}

export default withStyles(styles)(DepartmentChip)